module.exports = __webpack_public_path__ + "static/media/preOrderSteps2.89e01b52.png";